"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function isNode() {
  // @ts-ignore
  var browser = process.browser;
  return typeof process !== 'undefined' && !browser;
}
exports.default = isNode;